module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "关联分析",
      "description": "帮助您监控和分析特定页面的来源及去向，从而优化网站页面路径，改善网站质量",
      "pos": "right",
      "date": _vm.timeSpan
    }
  }), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "关联页列表"
    }
  }, [_c('small', {
    staticClass: "table-title-tip"
  }, [_vm._v("（此站点共可设置20个关联页）")])]), _c('div', {
    staticClass: "header-chart-line"
  }), _c('div', {
    staticClass: "zone-search"
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": _vm.openNewAssoModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("添加关联页")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableQuery),
      expression: "tableQuery"
    }],
    attrs: {
      "placeholder": "搜索内容..."
    },
    domProps: {
      "value": _vm._s(_vm.tableQuery)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.pageNum = 1;
        _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tableQuery = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-small btn-primary",
    on: {
      "click": function($event) {
        _vm.pageNum = 1;
        _vm.searchTable()
      }
    }
  }, [_vm._v("搜索")])]), _c('table', {
    staticClass: "data-table",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_vm._m(0), _c('tbody', [_vm._l((_vm.tableList.slice((_vm.pageNum - 1) * 4, (_vm.pageNum - 1) * 4 + 4)), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isListLoading && _vm.tableList.length),
        expression: "!isListLoading && tableList.length"
      }],
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(item.title))]), _c('td', [_c('a', {
      attrs: {
        "title": _vm._f("httpUrl")(item.url)
      }
    }, [_vm._v(_vm._s(_vm._f("httpUrl")(item.url)))])]), _c('td', [_vm._v(_vm._s(item.createDate))]), _c('td', {
      staticClass: "operate-cell"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg",
      attrs: {
        "title": "查看关联页"
      },
      on: {
        "click": function($event) {
          _vm.showAssoInfo(item)
        }
      }
    }), _c('i', {
      staticClass: "fa fa-trash-o fa-lg",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.deleteAsso(item)
        }
      }
    })])])
  }), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isListLoading && _vm.tableList.length === 0),
      expression: "!isListLoading && tableList.length === 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无数据")])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListLoading),
      expression: "isListLoading"
    }]
  }, [_vm._m(1)])], 2)]), _c('v-pagination', {
    attrs: {
      "total": _vm.totalListNum,
      "pn": _vm.pageNum,
      "ps": "4"
    },
    on: {
      "updatepage": _vm.onPageChange
    }
  })], 1), _c('timeSpan', {
    attrs: {
      "filters": "yesterday"
    },
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('div', {
    staticClass: "sanky-chart-wrap"
  }, [_c('a', {
    staticClass: "btn"
  }, [_vm._v(_vm._s(_vm.currentItem && _vm.currentItem.title))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sankyVisible),
      expression: "!sankyVisible"
    }],
    staticClass: "sanky-chart-mask"
  }), _c('div', {
    ref: "sankyChart",
    attrs: {
      "id": "sankyChart"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSankyLoading),
      expression: "isSankyLoading"
    }],
    staticClass: "loadingchart"
  })]), _c('v-modal', {
    attrs: {
      "visible": _vm.modalVisible,
      "title": "添加关联页"
    },
    on: {
      "closemodal": function($event) {
        _vm.modalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "min-width": "520px"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('dl', {
    staticClass: "item"
  }, [_c('dt', {
    staticClass: "label"
  }, [_vm._v("关联页名称")]), _c('dd', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAssoInfo.urlName),
      expression: "newAssoInfo.urlName"
    }],
    ref: "urlNameInput",
    staticClass: "size-normal",
    attrs: {
      "placeholder": "请输入1-50字符名称"
    },
    domProps: {
      "value": _vm._s(_vm.newAssoInfo.urlName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAssoInfo.urlName = $event.target.value
      }
    }
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAssoError.urlName.len),
      expression: "newAssoError.urlName.len"
    }],
    staticClass: "error"
  }, [_vm._v("最多填写50个字符")])])]), _c('dl', {
    staticClass: "item"
  }, [_c('dt', {
    staticClass: "label"
  }, [_vm._v("页面地址")]), _c('dd', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAssoInfo.url),
      expression: "newAssoInfo.url"
    }],
    ref: "urlInput",
    staticClass: "size-normal",
    attrs: {
      "placeholder": "请输入URL 如：http://aaa.com"
    },
    domProps: {
      "value": _vm._s(_vm.newAssoInfo.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAssoInfo.url = $event.target.value
      }
    }
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newAssoError.url.reg && _vm.newAssoError.url.len),
      expression: "!newAssoError.url.reg && newAssoError.url.len"
    }],
    staticClass: "error"
  }, [_vm._v("长度不得大于 1000")]), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAssoError.url.reg),
      expression: "newAssoError.url.reg"
    }],
    staticClass: "error"
  }, [_vm._v("请输入正确格式的 URL")]), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAssoError.url.duplicate),
      expression: "newAssoError.url.duplicate"
    }],
    staticClass: "error"
  }, [_vm._v("列表中已存在该地址")])])]), _c('dl', {
    staticClass: "item"
  }, [_c('dt', {
    staticClass: "label"
  }, [_vm._v("匹配类型")]), _c('dd', {
    staticClass: "control"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAssoInfo.matchtype),
      expression: "newAssoInfo.matchtype"
    }],
    attrs: {
      "options": [{
        title: '完全匹配',
        value: 1
      }, {
        title: '模糊匹配',
        value: 2
      }]
    },
    domProps: {
      "value": (_vm.newAssoInfo.matchtype)
    },
    on: {
      "input": function($event) {
        _vm.newAssoInfo.matchtype = $event
      }
    }
  })], 1)])])]), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-medium",
    class: {
      disabled: !_vm.canSubmit
    },
    attrs: {
      "type": "button",
      "value": "提交"
    },
    on: {
      "click": _vm.addNewAsso
    }
  }), _c('input', {
    staticClass: "btn btn-default btn-medium",
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": function($event) {
        _vm.modalVisible = false
      }
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40"
    }
  }), _c('th', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("关联页名称")]), _c('th', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("页面地址")]), _c('th', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("创建日期")]), _c('th', {
    attrs: {
      "width": "120"
    }
  }, [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42b77eb4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42b77eb4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/associate.vue
// module id = 744
// module chunks = 0